var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayTrack = function SvgPlayTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.19 11.23 5.618-4.899a.417.417 0 0 0 0-.627L1.193.774a.417.417 0 0 0-.692.313v9.83a.417.417 0 0 0 .69.314",
    clipRule: "evenodd"
  })));
};
export default SvgPlayTrack;